import { createSelector } from '@reduxjs/toolkit';

import { ClassRelationshipItem } from 'src/containers/ProjectDiagram/components/classDrawer/types';
import { RelationshipDirection } from 'src/containers/ProjectDiagram/constants/modelConcept';
import { NodeData } from 'src/containers/ProjectDiagram/types/model';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { classDraftChangesSelector } from 'src/selectors/draftClass';
import { projectClassRelationshipsSelector } from 'src/selectors/projectClassRelationships';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import * as copy from 'src/templates/copy';

export const projectClassRelationshipItemsSelector = (
  projectId: string,
  classIri: string,
  nodeData: NodeData | null
) =>
  createSelector(
    projectClassRelationshipsSelector(projectId, classIri),
    projectLabelsByIriSelector(projectId),
    classDraftChangesSelector(projectId, classIri),
    (classRelationshipsByIri, labelsByIri, { modifiedRelationships }) =>
      nodeData
        ? Object.values(classRelationshipsByIri).map<
            ClassRelationshipItem & { depth: number }
          >(({ depth, iri, domains, ranges }) => {
            const directions: RelationshipDirection[] = [];
            if (domains.has(classIri)) {
              directions.push(RelationshipDirection.OUTGOING);
            }
            if (ranges.has(classIri)) {
              directions.push(RelationshipDirection.INCOMING);
            }

            return {
              text: getLabelForIri(
                labelsByIri,
                iri,
                copy.components.projectDiagram.modelConceptRelationship.new
              ),
              value: iri,
              directions,
              depth,
              highlighted: modifiedRelationships.has(iri),
            };
          })
        : []
  );
